import { render } from "./plan-accordion.vue?vue&type=template&id=17b15786"
import script from "./plan-accordion.vue?vue&type=script&lang=js"
export * from "./plan-accordion.vue?vue&type=script&lang=js"

import "./plan-accordion.vue?vue&type=style&index=0&id=17b15786&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__